import { SendIcon } from "../../../../assets/svgIcons";
import primaryComponents from "../../../primaryComponents";
import { usePOSendEmail } from "./usePOSendEmail";
import { useValidation } from "./useValidation";

export const POSendEmail = ({ pODetails = {}, closeModal = () => {} }) => {
  const { isSendingPo, formData, setFormData, handleSendEmail } =
    usePOSendEmail({
      pODetails,
      closeModal,
    });
  const {
    register,
    control,
    formState: { errors },
    trigger,
    handleSubmit,
  } = useValidation({ ...formData });

  return (
    <form onSubmit={handleSubmit(handleSendEmail)}>
      <primaryComponents.InputFieldV2
        control={control}
        register={register}
        name="supplier_name"
        label="Supplier Name"
        placeholder="Enter supplier name"
        isRequired
        classNames="white"
        value={formData.supplier_name}
        errorMessage={errors?.supplier_name}
        onKeyUp={() => errors?.supplier_name && trigger("supplier_name")}
        onChange={({ target: { value } }) =>
          setFormData({ ...formData, supplier_name: value })
        }
      />
      <primaryComponents.InputFieldV2
        control={control}
        register={register}
        name="supplier_email"
        label="Supplier Email"
        placeholder="Enter supplier email"
        isRequired
        classNames="white"
        value={formData.supplier_email}
        errorMessage={errors?.supplier_email}
        onKeyUp={() => errors?.supplier_email && trigger("supplier_email")}
        onChange={({ target: { value } }) =>
          setFormData({ ...formData, supplier_email: value })
        }
      />

      <div className="d-flex mt-4" style={{ gap: "10px" }}>
        <primaryComponents.Button
          classNames={"btn btn--primary cover"}
          onClick={() => handleSendEmail(pODetails)}
          disabled={isSendingPo}
          isDisabled={isSendingPo}
          isLoading={isSendingPo}
          loadingText={"Sending..."}
        >
          <SendIcon className="mr-2" /> Send
        </primaryComponents.Button>
      </div>
    </form>
  );
};
